import { useQuery } from '@tanstack/react-query'

import { FetchStaffDetail } from '@/services/StaffService'

/**
 * One staff member's full record.
 *
 * Requested only once the card holding it is open, so listing an organization
 * with a large staff costs a single request rather than one per member. The
 * result is cached, so opening a card a second time does not re-request it.
 */
export const useStaffDetail = (orgId: string, staffId: string, isOpen: boolean) => {
  return useQuery({
    queryKey: ['staff', orgId, staffId],
    queryFn: () => FetchStaffDetail(orgId, staffId),
    enabled: Boolean(orgId) && Boolean(staffId) && isOpen,
  })
}
